export default "__VITE_ASSET__BKqNsEdJ__"